<div class="form-group form-group-input {{ classNameInputForm }}">
  <div class="group-label-and-input">
    <app-label
      [className]="classNameLabel"
      [required]="required"
      [label]="label"
      [formControlName]="formControlName"
    ></app-label>
    <div
      [ngClass]="{
        'input-group input-group-merge': ref?.children?.length,
        'box-input-group-error': control.invalid && submit,
        'input-disabled': disabled
      }"
      class="box-input-group {{ classNameInput }}"
    >
      <input
        #elementRef
        [id]="formControlName"
        [type]="type"
        class="form-control"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [ngClass]="{ 'input-error': control.invalid && submit }"
      />
      <div #ref>
        <ng-content></ng-content>
      </div>
      <ng-container *ngIf="loading$ | async">
        <div class="loading-input">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <app-validation-message
    class="field-error"
    *ngIf="control && control.invalid && submit"
    [validation]="control.errors"
  ></app-validation-message>
</div>
